export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16 doc-pb28">1. 倘若客戶要求並授權盈寶證券國際（香港）有限公司（「盈寶證券」）作為其代理人及為客戶或其他任何人士的利益申請於聯交所新上市和/或新發行的證券，為了盈寶證券的利益，客戶保證在該等申請作出時盈寶證券有權代表客戶作出該等申請。</div>

    <div class="doc-text doc-pb28">2. 客戶應熟悉並遵從任何招股說明書及/或發行文件、申請表格或其他有關文件內所載之管轄新上市及/或發行證券及其申請之全部條款及細則，客戶同意在與盈寶證券進行的任何交易中受該等條款及細則約束。</div>

    <div class="doc-text doc-pb28">3. 客戶向盈寶證券作出新上市及/或發行證券申請人（不論是向有關證券的發行人、保薦人、承銷人或配售代理人、聯交所或任何其他相關監管機構或人士）需要作出的所有聲明、保證和承諾。</div>

    <div class="doc-text doc-pb28">4. 客戶聲明及保證，並授權盈寶證券通過任何申請表格（或以其他方式）向聯交所和任何其他適合人士披露及保證，為受益予客戶或客戶在申請中載明的受益人士，盈寶證券作為客戶代理人作出的任何申請是客戶或盈寶證券代表客戶作出唯一的申請或打算作出的唯一申請。客戶確認並接受，就盈寶證券作為客戶代理人作出的任何申請而言，盈寶證券和有關證券的發行人、保薦人、承銷人或配售代理人、聯交所或任何其他相關監管機構或人士會依賴上述聲明及保證。</div>

    <div class="doc-text doc-pb28">5. 客戶聲明及保證，客戶是一個合資格根據招股說明書及/或發行文件及申請表格或任何其他有關此新上市及/或發行證券文件申請於聯交所新上市及/或新發行的證券的人士，及明白盈寶證券將會倚賴此聲明及保證。</div>

    <div class="doc-text doc-pb28">6. 客戶承認並明白，證券申請的法律和監管規定及市場慣例不時變化，而任何一種新上市或新發行證券的規定亦會變更。客戶承諾會按盈寶證券不時絕對酌情權決定的法律和監管規定及市場慣例的要求，向盈寶證券提供資料並採取額外的步驟和作出額外的聲明、保證和承諾。</div>

    <div class="doc-text doc-pb16">7. 有關盈寶證券或其代理人爲盈寶證券本身及/或客戶及/或為盈寶證券之其他客戶進行大額申請時，客戶確認並同意：</div>
    <div class="doc-text doc-pb16">(i) 該大額申請可能會因與客戶及客戶申請無關的理由而被拒絕，而在沒有欺詐、疏忽和故意違約的情況下，盈寶證券和其代理人無須就該拒絕對客戶或任何其他人士負上責任；及</div>
    <div class="doc-text doc-pb28">(ii) 倘若該大額申請因聲明和保證被違反或任何與客戶有關的理由而被拒絕，客戶需向盈寶證券作出賠償。客戶確認，客戶亦會對其他受上述違反或其他理由影響的人士的損失負上責任。</div>

    <div class="doc-text doc-pb28">8. 盈寶證券在收到客戶要求申請新股股票時，盈寶證券可向客戶提供該新股融資。由於就該新股融資或其他事項為客戶欠付到期及須即時繳付之所有本金、利息、及其他款項（「有抵押負債」）作出之持續性擔保，客戶作為實益擁有人以第一固定抵押形式向盈寶證券抵押新股股票，直至客戶向盈寶證券全數付清有抵押新股融資; 客戶茲此表明授權盈寶證券就受抵押股票之任何部份收取及運用盈寶證券收到之所有金額，不論該金額之性質，並以盈寶證券全權決定之方式及時間支付有抵押負債。</div>

    <div class="doc-text doc-pb28">9. 如有新股延遲或取消上市的情況，盈寶證券不會就客戶因該等情況而直接或間接產生的任何損失或支出承擔任何的責任。</div>

     <div class="doc-text doc-pb16">10. IPO融資申購風險提示: </div>
    <div class="doc-text doc-pb16">(i) IPO融資申購具有高槓桿風險。在上市當日，可能增加帳戶的潛在風險。中籤用戶需確保帳戶內有足夠的自有資金，否則在上市當日，若發生保證金追繳，盈寶證券有權在特定情況下賣出客戶部分或全部股票。因保證金追繳導致盈寶證券賣出客戶股票所造成的投資損失，須由客戶自行承擔。</div>
    <div class="doc-text doc-pb16">11. 使用貨幣基金抵押打新提示信息: </div>
    <div class="doc-text doc-pb16">(i) 請注意，貨幣基金並非等同於現金，其贖回款項可能因處理流程存在延遲，無法在新股申購截止限期前順利到賬。若因此導致您無法按要求支付預付認購資金，進而造成新股申購失敗，相關風險與責任將由客戶自行承擔。</div>
    <div class="doc-text doc-pb16">(ii) 此外，若貨幣基金贖回款未能及時到賬，而盈寶證券為客戶墊付 10% 的預付認購資金（註：盈寶證券並非必然提供墊付服務），客戶需根據規定支付相應的利息費用。 </div>
    <div class="doc-text doc-pb16">(iii) 為避免產生額外成本或影響新股申購計劃，請您務必提前做好資金安排，仔細閱讀並瞭解相關業務規則，充分認知潛在的費用與風險，確保申購流程順利進行。 </div>
  </div>
`
